import { UIComponent } from "@aptus/frontend-core";
import { AutoCompleteSelect } from "components/form/autoCompleteSelect/autoCompleteSelect";
import { DomainSelectProps, useDomainSelect } from "./useDomainSelect";

export const DomainSelect: UIComponent<DomainSelectProps> = (props) => (
	<AutoCompleteSelect {...useDomainSelect(props)} />
);
